export default __webpack_public_path__ + "static/media/640_dummy2016-schauspieler01-mobile-de.d1cb3cf0.png";